import type { SocialLogin as SocialLoginPlugin } from "@capgo/capacitor-social-login";

let ready: Promise<typeof SocialLoginPlugin> | null = null;

/**
 * The Capacitor social-login plugin, initialized once. _app starts it when the browser is first idle;
 * a Google sign-in button awaits it, so a tap before then still signs in. It used to be imported and
 * initialized in _app's start-up on every page (45 KB of the shell; ortex-gui#1285).
 *
 * An installed app shell may carry an older native plugin (or none): initialization then fails with a
 * warning and the plugin is returned anyway, so sign-in fails on its own, as before. If the code itself
 * fails to load (offline, or a deploy since the page loaded), the next call tries again.
 */
export const socialLogin = (): Promise<typeof SocialLoginPlugin> => {
    if (!ready) {
        ready = import("@capgo/capacitor-social-login").then(async ({ SocialLogin }) => {
            try {
                await SocialLogin.initialize({
                    google: {
                        webClientId: process.env.NEXT_PUBLIC_WEB_CLIENT_ID,
                        iOSClientId: process.env.NEXT_PUBLIC_IOS_CLIENT_ID,
                        iOSServerClientId: process.env.NEXT_PUBLIC_WEB_CLIENT_ID,
                    },
                });
            } catch (e) {
                console.warn("Social login unavailable", e);
            }
            return SocialLogin;
        });
        ready.catch(() => {
            ready = null;
        });
    }
    return ready;
};
